import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TravelService } from 'src/app/_services/travel.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-modal-cancel-travel',
  templateUrl: './modal-cancel-travel.component.html',
  styleUrls: ['./modal-cancel-travel.component.scss']
})
export class ModalCancelTravelComponent implements OnInit {

  formGroup!: FormGroup;
  modalRef!: NgbModalRef;

  @ViewChild('modal')
  modal: TemplateRef<any> | null = null;

  idsTrips: string[] = [];
  isReadOnlyMode: boolean = false;
  cancellationReason: string = '';
  isProcessing: boolean = false;
  isManagerCancellation: boolean = false;
  managerCancellationReasons = [
    { value: 'TROCA DE MOTORISTA', text: 'TROCA DE MOTORISTA' },
    { value: 'TROCA DE VEICULO', text: 'TROCA DE VEICULO' },
    { value: 'CELULAR DO MOTORISTA NAO É COMPATIVEL', text: 'CELULAR DO MOTORISTA NAO É COMPATIVEL' },
    { value: 'MOTORISTA NAO USOU O APP', text: 'MOTORISTA NAO USOU O APP' },
    { value: 'OUTRO', text: 'OUTRO' }
  ];

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private travelService: TravelService
  ) {
    this.formGroup = this.formBuilder.group({
      'justification': [''],
    });
  }

  ngOnInit(): void {}

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    if (!this.isProcessing) return;
    event.preventDefault();
    event.returnValue = '';
  }

  @HostListener('window:popstate', ['$event'])
  handlePopState(event: PopStateEvent): void {
    if (!this.isProcessing) return;
    event.preventDefault();
    window.history.pushState(null, '', window.location.href);
  }

  onSubmit() {
    if (this.isReadOnlyMode) {
      this.modalRef?.close();
      return;
    }
    
    if (this.isProcessing) return;

    const justification = this.formGroup.get('justification')?.value as string;
    if (!justification || justification.trim() === '') return;

    const idsValidos = this.idsTrips.filter(id => !!id);
    if (idsValidos.length === 0) return;

    this.isProcessing = true;
    window.history.pushState(null, '', window.location.href);

    const requests = idsValidos.map(id => this.travelService.cancel(id, justification));
    forkJoin(requests).subscribe({
      next: () => {
        if (this.modalRef) this.modalRef.close();
        this.formGroup.reset();
        this.isProcessing = false;
      },
      error: (err) => {
        console.error("Erro ao cancelar viagem", err);
        this.isProcessing = false;
      }
    });
  }

 
  openModal(idTrip: string, isManagerCancellation: boolean = false) {
    this.isProcessing = false;
    this.isReadOnlyMode = false;
    this.isManagerCancellation = isManagerCancellation;
    this.cancellationReason = '';
    this.idsTrips = [idTrip];
    this.formGroup.reset();
    //console.log("Abrindo modal para cancelar viagem:", this.idsTrips);
    this.modalRef = this.modalService.open(this.modal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  openModalMultiple(idsTrips: string[], isManagerCancellation: boolean = false) {
    this.isProcessing = false;
    this.isReadOnlyMode = false;
    this.isManagerCancellation = isManagerCancellation;
    this.cancellationReason = '';
    this.idsTrips = idsTrips.filter(id => !!id); 
    this.formGroup.reset();
    //console.log("Abrindo modal para cancelar várias viagens:", this.idsTrips);
    this.modalRef = this.modalService.open(this.modal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  openReadOnlyModal(reason: string, idTrip?: string) {
    this.isProcessing = false;
    this.isReadOnlyMode = true;
    this.isManagerCancellation = false;
    this.idsTrips = idTrip ? [idTrip] : [];
    this.cancellationReason = reason?.trim() || 'Motivo do cancelamento não informado.';
    this.formGroup.reset();
    this.modalRef = this.modalService.open(this.modal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

}
